import React from 'react'

const TextArea = React.forwardRef((props, ref) => (
  <label className='partner-label'>
    {props.label}
    <textarea {...props} ref={ref} className='form-control' rows={props.rows || '3'}></textarea>
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default TextArea
